import { Obj3d } from './obj3d';
import * as THREE from 'three';

export class Poste3d extends Obj3d {

	// Constantes de los tipos de postes.
	public static readonly D60 = 'D60';
	public static readonly C60 = 'C60';
	public static readonly LUX50 = 'LUX50';				// + 'B' bayoneta simple.
	public static readonly LUX80 = 'LUX80';				// + 'B' bayoneta simple y 'BD' bayoneta doble.
	public static readonly LUX50G = 'LUX50G';			// + 'B' bayoneta simple.
	public static readonly LUX80G = 'LUX80G';			// + 'B' bayoneta simple y 'BD' bayoneta doble.
	public static readonly RitmoDH = 'RitmoDH';			// + 'B' bayoneta simple.
	public static readonly RitmoCLIP = 'RitmoCLIP';		// + 'B' bayoneta simple.

	constructor(path: string, debug = false) {
		super(path, debug);
		this._data = {
			'D60': { estado: 0, archivo: 'PosteD60', carpeta: 'postes', mesh: undefined, length: 0.06 },
			'C60': {estado: 0, archivo: 'PosteD60_CUADRADO', carpeta: 'postes', mesh: undefined, length: 0.06 },
			'LUX50': { estado: 0, archivo: 'PosteLUX50', carpeta: 'postes', mesh: undefined, length: 0.05 },
			'LUX50B': { estado: 0, archivo: 'PosteLUX50B', carpeta: 'postes', mesh: undefined, length: 0.05 },
			'LUX80': { estado: 0, archivo: 'PosteLUX80', carpeta: 'postes', mesh: undefined, length: 0.08 },
			'LUX80B': { estado: 0, archivo: 'PosteLUX80B', carpeta: 'postes', mesh: undefined, length: 0.08 },
			'LUX80BD': { estado: 0, archivo: 'PosteLUX80BD', carpeta: 'postes', mesh: undefined, length: 0.08 },
			'LUX50G': { estado: 0, archivo: 'PosteLUX50G', carpeta: 'postes', mesh: undefined, length: 0.05 },
			'LUX50GB': { estado: 0, archivo: 'PosteLUX50GB', carpeta: 'postes', mesh: undefined, length: 0.05 },
			'LUX80G': { estado: 0, archivo: 'PosteLUX80G', carpeta: 'postes', mesh: undefined, length: 0.08 },
			'LUX80GB': { estado: 0, archivo: 'PosteLUX80GB', carpeta: 'postes', mesh: undefined, length: 0.08 },
			'LUX80GBD': { estado: 0, archivo: 'PosteLUX80GBD', carpeta: 'postes', mesh: undefined, length: 0.08 },
			'RitmoDH': { estado: 0, archivo: 'PosteRitmoDH', carpeta: 'postes', mesh: undefined, length: 0.05 },
			'RitmoDHB': { estado: 0, archivo: 'PosteRitmoDHB', carpeta: 'postes', mesh: undefined, length: 0.05 },
			'RitmoCLIP': { estado: 0, archivo: 'PosteRitmoCLIP', carpeta: 'postes', mesh: undefined, length: 0.05 },
			'RitmoCLIPB': { estado: 0, archivo: 'PosteRitmoCLIPB', carpeta: 'postes', mesh: undefined, length: 0.05 }
		};
	}

	// Bayoneta NO (''), simple ('B'), doble ('BD').
	public clonePost(type: string, name: string, x: number, y: number, direction: number): any {
		/*
		console.log(name);
		if(name == "poste_0_6") {
			console.trace();
		}
		*/
		//console.trace();
		//console.log("clonePost");

		let post = this.clone(type);
		if (post) {
			post.name = name;
			post.position.x = x;
			post.position.y = y;
			post.scale.z = direction;
		}
		return post;
	}

	// Clona los materiales con el color indicado, tiene en cuenta la opción de bayoneta.
	public clonePosteMaterial(type: string, colorStyle: string): { poste: THREE.MeshPhongMaterial[], bayoneta: THREE.MeshPhongMaterial[] } {
		// Resultado de todos (POSTE Y BAYONETA) los objetos 3D que componen el poste.
		let newMats = { poste: [], bayoneta: [] };

		// Obtener los datos del poste.
		let obj = this._data[type].mesh;

		// En caso de no existir no seguir.
		if (obj) {
			// Los postes puede tener un objeto o como máximo 4.
			// De todos los objetos los únicos que se modifican son los 'Poste' y 'BAYONETA'.
			// Recorrer todos los hijos del modelo.
			for (let o = 0; o < obj.children.length; o++) {

				// Puntero a los materiales del objeto.
				let mats = obj.children[o].material;

				// En caso de ser un objeto 'Poste'.
				if (obj.children[o].name.startsWith('Poste')) {
					// Los postes tienen como mínimo dos materiales.
					for (let m = 0; m < mats.length; m++) {
						// Solo modificamos el material que empieza por 'COL_'.
						if (mats[m].name.startsWith('COL_')) {
							// Clonamos el material para evistar modificar los ya existentes.
							let aux = mats[m].clone();
							// Asignamos el color del perímetro.
							aux.color.setStyle(colorStyle);
							// Guardar en cache.
							newMats.poste.push(aux);
						}
						else {
							// Material que no es necesario modificar.
							newMats.poste.push(mats[m]);
						}
					}
				}
				// En caso de ser un objeto 'BAYONETA'.
				else if (obj.children[o].name.startsWith('BAYONETA')) {
					// Las bayonetas tienen como mínimo dos materiales.
					for (let m = 0; m < mats.length; m++) {
						// Solo modificamos el material que empieza por 'COL_'.
						if (mats[m].name.startsWith('COL_')) {
							// Clonamos el material para evistar modificar los ya existentes.
							let aux = mats[m].clone();
							// Asignamos el color del perímetro.
							aux.color.setStyle(colorStyle);
							// Guardar en cache.
							newMats.bayoneta.push(aux);
						}
						else {
							// Material que no es necesario modificar.
							newMats.bayoneta.push(mats[m]);
						}
					}
				}
			}
		}
		return newMats;
	}
}